const alertIMI = {
	el: {
		btnToggleAlerts: document.querySelectorAll('.js-toggle-alert-imi')
	},

	fxToggleAlertIMI (target) {
		const oldValue = target.checked

		$.ajax({
			type: 'POST',
			async: true,
			url: target.dataset.route,
			data: {
				id: target.dataset.id,
				subscriptionId: target.dataset.subscription
			},
			success: function (response) {
				target.checked = response.value
			},
			error: function (response) {
				alert('Ocorreu um erro ao alterar o estado do alerta!')
				target.checked = oldValue
			}
		})
	},

	events () {
		for(const btn of this.el.btnToggleAlerts) {
			btn.addEventListener('change', e => this.fxToggleAlertIMI(e.currentTarget))
		}
	},

	init() {
		if(this.el.btnToggleAlerts.length === 0) return
		this.events()
	}
}

alertIMI.init()